import { ArrowBackOutlined } from "../../materialUi/materialUi";
import { ButtonDS } from "../Button";
import { TextCapitalized } from "../text/TextCapitalized";
import { Spacer } from "../Spacer";
import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ImportContent } from "./ImportContent";
import { type ImportError } from "./ImportErrorCell";

export type { ImportError };

export type ImportWithTemplateModalProps = {
  visible: boolean;
  onCloseModal: () => void;
  title: string;
  returnButtonText: string;
  template: {
    fileName: string;
    columns: string[];
    sheetName: string;
  };
  validateRows: (rows: unknown[][]) => ImportError[];
  onSubmit: (file: File) => void;
  errorTypeToLabel: (errorType: string) => string;
};

export const ImportWithTemplateModal = (
  props: ImportWithTemplateModalProps,
) => {
  const { t } = useTranslation();

  if (!props.visible) {
    return;
  }

  return (
    <StyledFrame>
      <Spacer x={2.5} />
      <StyledColumn>
        <Spacer y={2.5} />
        <div>
          <ButtonDS
            text={props.returnButtonText}
            leftIcon={<ArrowBackOutlined />}
            onClick={props.onCloseModal}
            buttonType={"secondary"}
            format={"hug"}
          />
        </div>
        <Spacer y={2.5} />
        <StyledContentImport>
          <StyledTitle>
            <TextCapitalized>{props.title}</TextCapitalized>
          </StyledTitle>
          <Spacer y={2} />
          <StyledFrameContainer>
            <ImportContent
              template={props.template}
              validateRows={props.validateRows}
              onSubmit={props.onSubmit}
              onCloseModal={props.onCloseModal}
              errorTypeToLabel={props.errorTypeToLabel}
            />
          </StyledFrameContainer>
          <Spacer y={2.5} />
        </StyledContentImport>
        <Spacer y={2.5} />
      </StyledColumn>
      <Spacer x={2.5} />
    </StyledFrame>
  );
};

const StyledFrame = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${colors["colors/surfaces/background/background_level0"]};
  border-radius: 0.75rem 0 0 0.75rem;
`;

const StyledColumn = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const StyledContentImport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;

const StyledFrameContainer = styled.div`
  max-width: 39.5rem;
  width: 100%;
  display: flex;
  padding: 3rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow:
    0px 2px 5px 0px rgba(143, 143, 143, 0.15),
    0px 0px 15px 0px rgba(143, 143, 143, 0.15);
  border-radius: 0.75rem;
  border: 0.0625rem solid transparent;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to left, #3cd3ad, #44b2d5) border-box;
  background-color: ${colors["colors/surfaces/background/background_level0"]};
`;

const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${typographies["Header/H3"]};
  color: ${colors["colors/text/black"]};
  width: 100%;
`;
